import React, { useState } from "react";
import { Table,  Button, Space, Col, Row, Modal, Tag } from "antd";
import PriceFormatter from "apps/Common/PriceFormatter";
import { EditOutlined, } from "@ant-design/icons";
import AddMLSRequest from "./AddMLS";
import dayjs from "dayjs";
import { openNotificationWithIcon } from "helpers/OpenNotificationWithIcon";
import { useSearchParams } from "react-router-dom";



const ResultFilter: React.FC<{ storeList: any[]; setStoreList: any }> = ({
  storeList,
  setStoreList,
}) => {
 const [selectedRecord,setSelectedRecord] = useState<any>(null)
  const [isShowAddMLSModal,setIsShowMLSModal] = useState(false)
  const [searchParams,setSearchParams] = useSearchParams()
  const advertId = searchParams.get("id");
  const handleSendRequestStore = async(record:any)=>{
    try {
      const data = {
        adverId:advertId,
        storeId:record.id
      }
  
    } catch (error:any) {
      openNotificationWithIcon("default",error?.message)
      console.log(error?.message)
    }
  }

  const columns = [
    {
      title: "İl, İlçe",
      
      key: "il",
      render: (_: any, record: any) => (
        <div className="!flex flex-col gap-2" >
          <div>

          <Tag color="blue" >{record?.city?.name||""}</Tag>
          </div>
         <div>

          <Tag color="green">{record?.district?.name||""}</Tag>
         </div>
        </div>
      ),
    },
    {
      title: "Firma Marka Adı",
      dataIndex: "storeName",
      key: "storeName",
    },
    {
      title: "Toplam İlan Sayısı",
      dataIndex: "advertCount",
      key: "advertCount",
    },
    {
      title: "Toplam İlan Değeri",
      dataIndex: "totalSalesAmount",
      key: "totalSalesAmount",
      render:(value:string)=>{
        return(
          <>
          <PriceFormatter  inputPrice={value} />
          </>
        )
      }
    },
    
    {
      title: "Üyelik Tarihi",
      dataIndex: "insertDate",
      key: "insertDate",
      render:(date:string)=>{
        return dayjs(date).format("DD.MM.YYYY")
      }
    },
    {
      title: "İşlem",
      key: "action",
      render: (_: any, record: any) =>
        {
          if(record?.portfolioUser?.length>0          )
          {

            return (
              <Button icon={<EditOutlined/>} className="!bg-black !text-white"
              onClick={async()=>{
                setSelectedRecord(record)
               setIsShowMLSModal(true)
              }}
              >
              İstek Gönderilecek Kullanıcıları Seçin
                </Button>
            )
          }
          else{
            return (
              <Button icon={<EditOutlined/>} className="!bg-black !text-white"
              onClick={async()=>{
                handleSendRequestStore(record) 
              }}
              >
               Mağazaya İstek at
                </Button>
            )
          }
        } 
    },
  ];





  

  return (
    <>
    <Col xs={24}>
      <Row gutter={[0, 20]}>
        <Col span={24} className="!flex justify-center">
          <Space>
            <span className="!text-2xl !font-bold">Filtre Sonuç Sayısı</span>
            <span className="!text-gray-400">({storeList.length||0} Adet)</span>
          </Space>
          
        </Col>
       
        <Col xs={24}>
          <Table
           
            rowKey={"id"}
            columns={columns}
            dataSource={storeList}
            pagination={false}
          />
        </Col>
      </Row>
    </Col>
    <Modal
    open={isShowAddMLSModal}
    onCancel={()=>{
      setIsShowMLSModal(false)
    }}
    width={"80%"}
    footer={false}
    title={false}
    >
      <AddMLSRequest
      selectedStore={selectedRecord}
      onFinish={()=>{
        setIsShowMLSModal(false)
      }} />

    </Modal>
    </>
  );
};

export default ResultFilter;
